import { FilterOperation, SubscriptionFilter } from 'api'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { createCollateralByIsinGetterSelector } from 'selectors/collateralSelectors'
import { TextInputField } from 'view/components/inputs'
import { getSubscriptionFilterValue } from '../utils'

interface IsinCusipSubscriptionFieldProps {
  subscriptionFilters: SubscriptionFilter[]
  handleUpdateFilterValue: (
    fieldName: string,
    filterOperation: FilterOperation,
    orFilter?: SubscriptionFilter | null
  ) => (value: any) => void
}

export const IsinCusipSubscriptionField: React.FC<IsinCusipSubscriptionFieldProps> = ({ subscriptionFilters, handleUpdateFilterValue }) => {
  const getCollateralByIsin = useSelector(createCollateralByIsinGetterSelector)

  const handleIsinCusipUpdate = (collateralId: string) => {
    const cusip = getCollateralByIsin(collateralId)?.cusip
    const orFilter: SubscriptionFilter | null = cusip
      ? {
          fieldName: 'collateralId',
          value: cusip,
          filterOperation: FilterOperation.EQUALS,
          orFilter: null,
          andFilter: null,
          calculatedValueType: null
        }
      : null
    return handleUpdateFilterValue('collateralId', FilterOperation.EQUALS, orFilter)(collateralId)
  }

  return (
    <TextInputField
      dataTestId={'AdvancedDealSubscriptionFilters-TextInput-ISINBUICUSIP'}
      label={Locale.translate(Translation.SC_FILTER_ISIN_BUI_CUSIP_EQUALS)}
      value={getSubscriptionFilterValue(subscriptionFilters, 'collateralId')}
      onUpdate={handleIsinCusipUpdate}
      autoCapitalise={true}
    />
  )
}
